module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-216.90c0298.woff2";